/**
 * Đơn vị tính số lượng gửi gia công theo công đoạn (FB-CYG54A):
 * in, cán màng, bế, kéo lụa, ép nhũ, phủ UV… tính theo tờ; dán, gấp, đóng gói tính theo pcs.
 * Ưu tiên đơn vị khai báo trên công đoạn; thiếu thì suy theo tên công đoạn.
 */
export const OUTSOURCE_UNITS = ["tờ", "pcs"] as const;

const PCS_KEYWORDS = /(dán|gấp|đóng gói|đóng thùng|kcs|kiểm|xỏ dây|quấn)/i;

/** Chuẩn hoá đơn vị công đoạn về "tờ" / "pcs" */
export function normalizeOutsourceUnit(unit?: string | null): string | null {
  const u = String(unit || "").trim().toLowerCase();
  if (!u) return null;
  if (["tờ", "to", "sheet", "sheets"].includes(u)) return "tờ";
  if (["cái", "cai", "pcs", "pc", "chiếc", "sp", "hộp"].includes(u)) return "pcs";
  return unit!.trim();
}

/** Đơn vị của một công đoạn: đơn vị khai báo, không có thì theo tên */
export function unitOfStep(step: { name?: string | null; unit?: string | null; process?: { unit?: string | null } | null }): string {
  return (
    normalizeOutsourceUnit(step.unit ?? step.process?.unit) ||
    (PCS_KEYWORDS.test(String(step.name || "")) ? "pcs" : "tờ")
  );
}

/** Đơn vị mặc định cho số lượng gửi gia công: theo công đoạn đầu tiên được gửi đi; chưa chọn công đoạn → pcs */
export function defaultOutsourceUnit(steps: Array<{ name?: string | null; unit?: string | null; process?: { unit?: string | null } | null }>): string {
  return steps.length ? unitOfStep(steps[0]) : "pcs";
}
